import styled from '@emotion/styled';
import { FileUploadContainer } from 'components/FileUpload/FileUpload.styles';

export const TrayDetailsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TrayAttributesContainer = styled.div`
  padding: 0 1rem;
  flex: 1;

  .label-container {
    margin-bottom: 0.5rem;
  }

  .MuiFormControlLabel-root {
    margin-left: 0;
  }
`;

export const TrayFileUploader = styled(FileUploadContainer)`
  width: 100%;
`;

export const TrayCheckboxContainer = styled.div`
  padding: 0.5rem 0;
`;

// export const
